import React from "react";
import moment from "moment";
import { t } from "i18next";
import C from "Constants";
import { useLang } from "hooks";
import PreviewMediaUrls from "components/brandHeader/PreviewMediaUrls";
import OrderStatusTag from "./OrderStatusTag";
import { PriceRender } from "components/DisplayPrice";



function OrderList({ orderList, handleOrderDetail }) {
  const { currentLang } = useLang();
  const list = orderList?.orders ?? orderList ?? [];

  const getOrderDetail = (order) => {
    let state = { order };
    handleOrderDetail(state);
  };

  const getOrderQuantity = (order) => {
    let quantity = 0;
    order?.forEach((item) => {
      quantity += item?.quantity;
    });
    return quantity;
  };

  return (
    <>
      {list?.map((order, key) => (
        <div
          onClick={() => getOrderDetail(order)}
          key={order?._id || key}
          className="cursor-pointer basket-item flex justify-between items-center gap-3"
        >
          <div className="relative flex-shrink-0 h-100x w-100x p-2">
            <PreviewMediaUrls
              sourceUrl={order?.itemImageURLs?.[0] ?? C.PLACEHODERIMAGE}
            />
          </div>
          <div className="flex flex-auto flex-col">
            <h2 className="text-16x font-bold text-dark-blue-900">
              {t(order?.storeInfo?.baseLanguage?.name)}
            </h2>
            <div className="flex gap-2 items-center">
              <span>
                {moment.unix(order?.orderPlacedTime).format("DD MMM")}
              </span>
              <span className="h-1 w-1 bg-dark-blue-900 rounded-full" />
              <span>{t("items count", { count: getOrderQuantity(order?.orderedMenu ?? []) })}</span>
              <span className="h-1 w-1 bg-dark-blue-900 rounded-full" />
              <span>
                <PriceRender price={+order?.totalOrderPrice} className="text-16x leading-none"  currencySymbolClassName="CURRENT"/>
              </span>
            </div>
            {order?.orderStatus && (
              <OrderStatusTag status={order?.orderStatus} />
            )}
          </div>
          <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            className={`h-18x w-18x transform text-brand-base-primary ${
              currentLang === "AR" ? "rotate-90" : "-rotate-90"
            }`}
          >
            <path
              fill="currentColor"
              d="M4.88398 7.11612L3.11621 8.88389L12.0001 17.7678L20.884 8.88389L19.1162 7.11612L12.0001 14.2322L4.88398 7.11612Z"
            ></path>
          </svg>
        </div>
      ))}
    </>
  );
}

export default OrderList;
